<template>
  <div id="app">
    <div>
      <Header class="headers-roof"/>
      <router-view v-if="isRouterAlive" />
      <Footer v-if="$route.meta.isFooter == 1" />
   
    </div>
  </div>
</template>
<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";


export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,

    };
  },
  mounted() {
  },
  methods: {
    reload() {
      this.logins = false;
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.logins = true;
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="less" scoped>
#app {
  min-width: 1250px;
  padding-top: 62px;
}
.headers-roof{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
</style>
